import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Task } from "@common/types/task";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { format } from "date-fns";
import { fullDateFullYearFormat, timeFormat } from "@common/helpers/date";
import { memo } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { NestedTaskRow } from "../../types";

export const UpdatedAtCell = memo(
    ({ row }: CellContext<ViewTableFeatures, NestedTaskRow, Date>) => {
        const task = row.original as Task;

        if (row.original.isGroup || row.original.isNewPlaceholder) {
            return null;
        }

        return (
            <ViewTableCell>
                {task.updatedAt ? (
                    <Tooltip content={format(task.updatedAt, timeFormat)}>
                        <div>
                            {format(task.updatedAt, fullDateFullYearFormat)}
                        </div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                )}
            </ViewTableCell>
        );
    },
);
